import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const ExportDropdownPanel = ({
  selectedOption,
  onOptionChange,
  onGenerate,
  onClickAway,
  sx = {},
}) => {
  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <Paper
        elevation={3}
        sx={{
          position: "absolute",
          top: "100%",
          right: 0,
          mt: 1,
          p: 2,
          zIndex: 10,
          minWidth: "180px",
          ...sx,
        }}
      >
        <MDTypography sx={{ mb: 1 }}>Export As</MDTypography>

        <RadioGroup value={selectedOption} onChange={(e) => onOptionChange(e.target.value)}>
          <FormControlLabel value="excel" control={<Radio />} label="Excel" />
          <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
          <FormControlLabel value="both" control={<Radio />} label="Both" />
        </RadioGroup>

        <MDButton
          variant="contained"
          color="info"
          fullWidth
          sx={{ mt: 1 }}
          onClick={onGenerate}
        >
          Generate
        </MDButton>
      </Paper>
    </ClickAwayListener>
  );
};

export default ExportDropdownPanel;
